"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { WaitlistForm } from "@/components/marketing/WaitlistForm";

/** Subset of Sanity pricing tier needed for the waitlist dialog. */
export interface IWaitlistFoundingTier {
  name: string;
  amountMonthly: number | null;
  currency: string;
}

interface IWaitlistDialogProps {
  foundingTier: IWaitlistFoundingTier | null;
  /** Extra className for the trigger button. */
  className?: string;
}

function formatPrice(cents: number, currency: string): string {
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

export function WaitlistDialog({
  foundingTier,
  className,
}: IWaitlistDialogProps): React.ReactElement {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" className={className}>
          Join Waitlist
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Join the Waitlist</DialogTitle>
          <DialogDescription>
            Be the first to know when we launch.
            {foundingTier != null && foundingTier.amountMonthly != null && (
              <>
                {" "}
                Lock in the{" "}
                <span className="font-semibold text-foreground">
                  {foundingTier.name}
                </span>{" "}
                rate at{" "}
                <span className="font-semibold text-foreground">
                  {formatPrice(foundingTier.amountMonthly, foundingTier.currency)}/mo
                </span>
                .
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <WaitlistForm />
      </DialogContent>
    </Dialog>
  );
}
